import script from "./GuildChannelGroupDelete.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuildChannelGroupDelete.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__